<input
  #inputElem
  type="text"
  pInputText
  class="osp-input-element"
  [formControl]="control()"
  [placeholder]="placeholder"
  [class]="cssClass"
  [variant]="variant"
  [pKeyFilter]="keyFilter"
  [readOnly]="readOnly"
  (focus)="onFocus.emit($event)"
  (focusout)="onFocusOut.emit($event)"
  (blur)="onBlur.emit($event)"
  (input)="onInput.emit($event)"
  [ospTrimInput]="$trimEnabled()"
/>

<osp-input-help-text [helpText]="helpText"></osp-input-help-text>
